// extracted by mini-css-extract-plugin
export default {"wrapper":"FeaturedComponent_wrapper__uEcpz"};